// Single source of truth for research focus areas
export const RESEARCH_AREAS = [
  {
    title: 'Machine Learning for Mental State Modeling',
    description:
      'Designing supervised, unsupervised, and representation-learning models to infer mental states from multimodal data.',
  },
  {
    title: 'Deep Learning on Physiological Signals',
    description:
      'Applying deep learning techniques to time-series physiological data such as heart rate, blood pressure, and other biosignals to identify patterns correlated with mental and emotional conditions.',
  },
  {
    title: 'AI-Assisted Clinical Systems',
    description:
      'Building intelligent systems that summarize, analyze, and surface clinically relevant patterns to help professionals understand patients more efficiently and consistently.',
  },
  {
    title: 'Human-AI Interaction in Clinical Contexts',
    description:
      'Studying how humans interact with AI systems in therapeutic and clinical settings, with a focus on trust, interpretability, and the ethical deployment of computational tools in sensitive domains.',
  },
];
